import { take, call, put } from 'redux-saga/effects';
import { reports as actionTypes } from '$constants/action-types';
import * as actions from '$actions/reports';
import axios from 'axios';

const fetchAll = params => axios.get(`/reports`, { params });

function* watchFetchAll() {
  while(true) {
    const action = yield take(actionTypes.FETCH_ALL);
    yield put(actions.fetchAllRequest());
    const { data } = yield call(fetchAll, action.params);
    const hasMore = data.meta.total_count / (25 * action.params.page) >= 1;
    yield put(actions.fetchAllSuccess(data.data, hasMore));
  }
}

export const watchers = [
  watchFetchAll
];



// WEBPACK FOOTER //
// ./src/sagas/reports.js